import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function FeaturedImagesSection({ fields, setFields, form }) {
  const addField = () => {
    const nextIndex = fields.length + 1;
    setFields(prev => [
      ...prev,
      {
        id: nextIndex,
        name: `featured_img_${nextIndex}`,
        label: `Featured Image ${nextIndex}`,
        file: null,
        alt: '',
      },
    ]);
  };

  const updateFile = (index, file) => {
    setFields(prev => {
      const updated = [...prev];
      updated[index].file = file;
      return updated;
    });
    form.setFieldsValue({
      [fields[index].name]: file,
    });
  };

  const updateAlt = (index, alt) => {
    setFields(prev => {
      const updated = [...prev];
      updated[index].alt = alt;
      return updated;
    });
  };

  const removeField = index => {
    setFields(prev => prev.filter((_, i) => i !== index));

    // Remove values from the form
    const fieldName = fields[index]?.name;
    const altName = `alt_${fields[index]?.name}`;
    if (fieldName) {
      form.setFieldsValue({
        [fieldName]: undefined,
        [altName]: undefined,
      });
    }
  };

  return (
    <div className="feature-images-holder">
      <div className="head">
        <span className="label">Featured Images</span>
        <button className="add-more" type="button" onClick={addField}>
          Add Image <i className="material-icons-outlined">add</i>
        </button>
      </div>
      <Grid xs={1} lg={3} colGap={10} rowGap={10}>
        {fields?.map((field, index) => (
          <div className="upload-field-holder" key={field?.id}>
            <Form.Item
              name={field?.name}
              type="chooseFile"
              small
              value={field?.file}
              displayFile={field.file?.preview || field?.file || null}
              fileName={field?.file?.name}
              deleteClick={() => removeField(index)}
              onChange={file => updateFile(index, file)}
              rules={[{ required: index < 4, message: `Select ${field?.label}` }]}>
              <Field />
            </Form.Item>
            <Form.Item
              name={`alt_${field?.name}`}
              type="text"
              placeholder="Alt"
              value={field?.alt}
              onChange={e => {
                updateAlt(index, e.target.value);
              }}
              sm
              rules={[{ required: false, message: 'Enter Alt' }]}>
              <Field />
            </Form.Item>
          </div>
        ))}
      </Grid>
    </div>
  );
}

export default FeaturedImagesSection;
